var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPictogramBeaconMoneyIn48(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 49,
    viewBox: "0 0 48 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1916_20223)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.5326 41.5025C9.35502 41.5025 8.40039 40.5383 8.40039 39.3628V19.0464C8.40039 17.8647 9.35118 16.9067 10.5326 16.9067H37.4682C38.6458 16.9067 39.6004 17.8709 39.6004 19.0464V39.3628C39.6004 40.5445 38.6496 41.5025 37.4682 41.5025H10.5326Z",
    fill: "white",
    stroke: "#1E1E1E",
    strokeWidth: 1.2,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.7246 20.5239H30.2763",
    stroke: "#1E1E1E",
    strokeWidth: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24 20.5242C27.6065 20.5242 30.5302 17.6093 30.5302 14.0136C30.5302 10.4178 27.6065 7.50293 24 7.50293C20.3934 7.50293 17.4697 10.4178 17.4697 14.0136C17.4697 17.6093 20.3934 20.5242 24 20.5242Z",
    fill: "#FAEC20",
    stroke: "#1E1E1E",
    strokeWidth: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.5088 16.5449H24.2415",
    stroke: "#1E1E1E",
    strokeWidth: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.4854 11.4814H25.2382",
    stroke: "#1E1E1E",
    strokeWidth: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.5193 11.4814C22.76 11.4814 22.1445 12.0482 22.1445 12.7474C22.1445 13.4466 22.76 14.0134 23.5193 14.0134",
    stroke: "#1E1E1E",
    strokeWidth: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.2072 14.0132C24.9665 14.0132 25.582 14.58 25.582 15.2791C25.582 15.9783 24.9665 16.5451 24.2072 16.5451",
    stroke: "#1E1E1E",
    strokeWidth: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.8506 11.5182V10.0347",
    stroke: "#1E1E1E",
    strokeWidth: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.8506 17.9469V16.4634",
    stroke: "#1E1E1E",
    strokeWidth: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.2413 14.0132H23.5093",
    stroke: "#1E1E1E",
    strokeWidth: 1.2
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1916_20223"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    fill: "white",
    transform: "translate(0 0.50293)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPictogramBeaconMoneyIn48);
export default __webpack_public_path__ + "static/media/pictogramBeaconMoneyIn48.c13c2658358bd72f86bc077464945cdf.svg";
export { ForwardRef as ReactComponent };